import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";
import SectionWrapper from "../../components/SectionWrapper/SectionWrapper";
import BackupSettingsPanel from "../../components/settings/backup/BackupSettingsPanel";

/**
 * 💾 Página de Respaldo del Sistema
 *
 * Aquí se administrarán los respaldos del sistema
 * y restauración de información.
 */
const BackupSettingsPage = () => {
  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <BackupSettingsPanel />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default BackupSettingsPage;
